var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H48C52.4183 0 56 3.58172 56 8V48C56 52.4183 52.4183 56 48 56H8C3.58172 56 0 52.4183 0 48V8Z",
    fill: "#FFE3B2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_182_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8091 24.05C33.1652 17.6488 22.8321 17.6512 16.1908 24.05C15.9411 24.2906 15.9362 24.698 16.1777 24.9477L17.4617 26.2746C17.692 26.5129 18.0625 26.518 18.3017 26.2895C23.7737 21.0676 32.2255 21.0664 37.6986 26.2895C37.9378 26.518 38.3083 26.5125 38.5386 26.2746L39.8226 24.9477C40.0637 24.698 40.0588 24.2906 39.8091 24.05ZM28 31.75C26.6743 31.75 25.6 32.8691 25.6 34.25C25.6 35.6309 26.6743 36.75 28 36.75C29.3256 36.75 30.4 35.6309 30.4 34.25C30.4 32.8691 29.3256 31.75 28 31.75ZM35.6001 28.4848C31.2778 24.5031 24.7172 24.5074 20.3998 28.4848C20.1411 28.7231 20.1328 29.1367 20.3785 29.3891L21.67 30.7168C21.895 30.9481 22.2572 30.9637 22.4968 30.7481C25.645 27.9133 30.3621 27.9195 33.5027 30.7481C33.7423 30.9637 34.1046 30.9484 34.3296 30.7168L35.6211 29.3891C35.8671 29.1367 35.8585 28.7227 35.6001 28.4848V28.4848Z",
    fill: "#FFA300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_182_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "white",
    transform: "translate(16 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWife);
export default __webpack_public_path__ + "static/media/wife.054ecee6a49ea815ba0db22e8d448f59.svg";
export { ForwardRef as ReactComponent };